import React from "react";
import { Grid } from "semantic-ui-react";
import "./App.css";
import { connect } from "react-redux";
import SidePanel from "./SidePanel/SidePanel";

import BlogsFeedMetaPanel from "./MetaPanel/BlogsFeedMetaPanel";
import Blogs from "./SidePanel/Blogs";

// prettier-ignore
const BlogsFeed = ({ currentUser, currentChannel, isPrivateChannel, userPosts, primaryColor, secondaryColor, cloudsFeedOn }) => (
  <React.Fragment>
  <SidePanel
      key={currentUser && currentUser.uid}
      currentUser={currentUser}
      primaryColor="#4267B2"
    />
  <Grid columns="equal" className="app" style={{ background: secondaryColor }}>
    {/* <ColorPanel
      key={currentUser && currentUser.name}
      currentUser={currentUser}
    /> */}
    

    <Grid.Column style={{ marginLeft:"1%", marginRight:"19%", marginTop: 20 }}>
      <Blogs bookmarkedBlogs={false}/>
      {/* <Header as='h1'>Blogs you can read</Header>
      <React.Fragment>
      <Item.Group divided>
        
    <Item>
      <Item.Content>
        <Item.Header as='h1' >12 Years a Slave</Item.Header>
        <Item.Meta>
          <span className='cinema'>Harsh Pratap Singh</span>
        </Item.Meta>
        <Item.Description style={{ fontSize: 16, textAlign:"justify" }}>This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.</Item.Description>
        <Item.Extra>

        <Label icon='tag' content='Feel good movies' />
          <Label icon='tag' content='Favourite Songs' />
        </Item.Extra>
      </Item.Content>
    </Item>
    <Item>
      <Item.Content>
        <Item.Header as='h1' >12 Years a Slave</Item.Header>
        <Item.Meta>
          <span className='cinema'>Harsh Pratap Singh</span>
        </Item.Meta>
        <Item.Description style={{ fontSize: 16, textAlign:"justify" }}>This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.</Item.Description>
        <Item.Extra>

        <Label icon='tag' content='Feel good movies' />
          <Label icon='tag' content='Favourite Songs' />
        </Item.Extra>
      </Item.Content>
    </Item>

    <Item>
      <Item.Content>
        <Item.Header as='h1' >12 Years a Slave</Item.Header>
        <Item.Meta>
          <span className='cinema'>Harsh Pratap Singh</span>
        </Item.Meta>
        <Item.Description style={{ fontSize: 16, textAlign:"justify" }}>This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly. This is an blog which you can read and get happy instantly.</Item.Description>
        <Item.Extra>

        <Label icon='tag' content='Feel good movies' />
          <Label icon='tag' content='Favourite Songs' />
        </Item.Extra>
      </Item.Content>
    </Item>
  </Item.Group>
      </React.Fragment> */}
    </Grid.Column>

    <Grid.Column width={3} style={{position:"absolute",right:"0%", marginTop: 20 }}>
      <BlogsFeedMetaPanel
        bookmarkedBlogs={false}
        key={currentChannel && currentChannel.name}
        userPosts={userPosts}
        currentChannel={currentChannel}
        isPrivateChannel={isPrivateChannel}
        
      />
    </Grid.Column>
  </Grid>
  </React.Fragment>
  
);

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentChannel: state.channel.currentChannel,
  isPrivateChannel: state.channel.isPrivateChannel,
  userPosts: state.channel.userPosts,
  primaryColor: state.colors.primaryColor,
  secondaryColor: state.colors.secondaryColor,
});

export default connect(mapStateToProps)(BlogsFeed);



// WEBPACK FOOTER //
// ./src/components/BlogsFeed.js